import React from "react";
import { Star } from "lucide-react";

const REVIEWS = [
  { name: "Karim B.", city: "Montreuil", rating: 5, date: "il y a 2 semaines", text: "WC complètement bouché un dimanche soir. Plombier arrivé en 25 minutes, problème réglé en 40 min, prix annoncé respecté. Sérieux et propre." },
  { name: "Sophie L.", city: "Saint-Denis", rating: 5, date: "il y a 1 mois", text: "Évier de cuisine qui ne s'écoulait plus du tout. L'équipe a passé la caméra, identifié des graisses, hydrocurage et nettoyage impeccable. Je recommande." },
  { name: "Mehdi R.", city: "Aubervilliers", rating: 5, date: "il y a 3 semaines", text: "Très bonne entreprise, devis clair avant intervention. Aucune mauvaise surprise sur la facture. Travail soigné, à appeler les yeux fermés." },
  { name: "Laetitia M.", city: "Bobigny", rating: 4, date: "il y a 2 mois", text: "Intervention rapide pour une évacuation bouchée. Le plombier était courtois et a tout nettoyé en partant. Petit délai d'attente mais rien de gênant." },
  { name: "Jean-Pierre D.", city: "Drancy", rating: 5, date: "il y a 1 semaine", text: "Curage de canalisation pour notre copropriété. Travail très professionnel, planning respecté, rapport remis au syndic. Parfait." },
  { name: "Fatou C.", city: "Pantin", rating: 5, date: "il y a 5 jours", text: "Toilettes bouchées avec eau qui remontait. Standard accueillant, plombier compétent, problème résolu sans démonter la cuvette. Bravo." },
  { name: "Olivier T.", city: "Noisy-le-Grand", rating: 5, date: "il y a 6 jours", text: "Très réactifs, j'ai eu un technicien en moins de 30 minutes en pleine nuit. Tarif honnête et travail efficace. Je garde le numéro." },
  { name: "Amélie F.", city: "Aulnay-sous-Bois", rating: 5, date: "il y a 3 semaines", text: "Service de qualité, transparent sur les tarifs. Le plombier a pris le temps de m'expliquer la cause du bouchon et comment l'éviter à l'avenir." },
  { name: "Hakim S.", city: "Le Blanc-Mesnil", rating: 4, date: "il y a 1 mois", text: "Bon rapport qualité-prix. L'évacuation de la salle de bain est de nouveau parfaitement fonctionnelle. Merci pour la rapidité." },
  { name: "Camille P.", city: "Bondy", rating: 5, date: "il y a 2 jours", text: "Appel passé à 22h, technicien sur place à 22h35. Très professionnel et calme face à mon stress. Recommande à 100%." },
  { name: "Yassine M.", city: "Sevran", rating: 5, date: "il y a 1 mois", text: "Entreprise sérieuse, facture détaillée envoyée par mail. Le plombier a même donné des conseils d'entretien. Top." },
  { name: "Nathalie K.", city: "Rosny-sous-Bois", rating: 5, date: "il y a 2 semaines", text: "Plombier ponctuel, courtois et compétent. A débouché une colonne d'évacuation difficile sans abîmer le carrelage. Je recommande vivement." },
];

const Stars = ({ n }) => (
  <div className="flex gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        className={`w-4 h-4 ${i < n ? "fill-[#FBBF24] text-[#FBBF24]" : "text-slate-300"}`}
      />
    ))}
  </div>
);

export const Reviews = () => {
  const avg = (REVIEWS.reduce((s, r) => s + r.rating, 0) / REVIEWS.length).toFixed(1);
  return (
    <section id="avis" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-6">
          <div>
            <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-[#FF5A1F] mb-4">
              Avis vérifiés
            </div>
            <h2
              className="text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0F172A]"
              style={{ fontFamily: "'Cabinet Grotesk','Manrope', sans-serif" }}
            >
              Nos clients témoignent.
            </h2>
          </div>
          <div className="flex items-center gap-4 bg-[#0F172A] text-white rounded-2xl px-6 py-4">
            <div>
              <div className="text-4xl font-black tracking-tight">{avg}</div>
              <Stars n={5} />
            </div>
            <div className="border-l border-white/20 pl-4">
              <div className="text-xs uppercase tracking-wider text-white/70">Note Google</div>
              <div className="font-bold">{REVIEWS.length}+ avis clients</div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <div
              key={i}
              data-testid={`review-card-${i}`}
              className="bg-white border border-slate-200 rounded-2xl p-6 hover:shadow-lg transition"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-[#0F172A] text-[#FF5A1F] flex items-center justify-center font-black">
                  {r.name[0]}
                </div>
                <div>
                  <div className="font-bold text-[#0F172A] text-sm">{r.name}</div>
                  <div className="text-xs text-slate-500">{r.city} · {r.date}</div>
                </div>
              </div>
              <Stars n={r.rating} />
              <p className="text-slate-600 text-sm mt-3 leading-relaxed">"{r.text}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
